import { Link } from "react-router-dom";
import Seo, { localBusinessSchema } from "@/components/Seo";
import Reveal from "@/components/Reveal";
import CtaBand from "@/components/CtaBand";
import { CLINIC_IMAGE, HERO_IMAGE } from "@/data/site";

const VALUES = [
  { n: "01", t: "Safety before everything", d: "People heal in rooms where they feel deeply safe. We build that feeling into every detail — the light, the pace, the tone." },
  { n: "02", t: "Evidence, gently held", d: "CBT, ACT, IFS and somatic care — the modern science of healing, delivered with old-soul warmth." },
  { n: "03", t: "The whole person", d: "Mind and body are not separate. We pair talk therapy with grounding, somatic tools that calm the nervous system." },
  { n: "04", t: "Your pace, always", d: "No prescribed timeline. No performance. Progress that respects your nervous system." },
];

export default function About() {
  return (
    <>
      <Seo
        title="Our Approach — About Let Go Wellness in Waterbury, CT"
        description="Let Go Wellness is a mental health therapy practice in Waterbury, CT built on one belief: people heal where they feel safe. Meet our approach and values."
        path="/about"
        image={CLINIC_IMAGE}
        jsonLd={localBusinessSchema}
      />
      <section className="border-b border-border">
        <div className="mx-auto max-w-4xl px-6 py-20 md:py-28">
          <Reveal>
            <div className="overline mb-6">Our approach</div>
            <h1 className="font-serif text-5xl leading-tight text-ink sm:text-6xl">What if healing didn't feel like <span className="italic text-clay">work?</span></h1>
            <p className="mt-8 max-w-2xl font-sans text-lg leading-relaxed text-ink-soft">
              Let Go Wellness was founded on a simple belief: people heal in rooms where they feel deeply safe. We're a mental health therapy practice in Waterbury, Connecticut, offering unhurried, evidence-based care in person and by secure telehealth across the state.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="border-b border-border">
        <div className="aspect-[21/9] w-full overflow-hidden"><img src={HERO_IMAGE} alt="Sunlit, linen-toned therapy space" className="h-full w-full object-cover" loading="lazy" /></div>
      </section>

      <section className="border-b border-border bg-white py-24">
        <div className="mx-auto max-w-5xl px-6">
          <div className="overline mb-10">What we believe</div>
          <div className="grid gap-px overflow-hidden border border-border bg-border sm:grid-cols-2">
            {VALUES.map((v) => (
              <div key={v.n} className="bg-white p-10">
                <div className="font-serif text-3xl italic text-clay">{v.n}</div>
                <h2 className="mt-4 font-serif text-2xl text-ink">{v.t}</h2>
                <p className="mt-3 font-sans text-base leading-relaxed text-ink-soft">{v.d}</p>
              </div>
            ))}
          </div>
          <p className="mt-10 max-w-2xl font-sans text-base leading-relaxed text-ink-soft">
            Curious who you'd be working with? <Link to="/therapists/waleska-castillo" className="text-clay underline-offset-4 hover:underline" data-testid="about-therapist-link">Meet Waleska Castillo, LPC</Link> — our bilingual, compassionate therapist.
          </p>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
